"use client";

import { type ContentSectionButton_Fields } from "~/__generated__/graphql";
import CustomLink from "./CustomLink";
import VideoPopup from "./VideoPopup";
import { useState } from "react";

const buttonClass =
  "flex h-14 w-full items-center justify-center rounded-sm border-blue bg-blue px-6 py-1 text-lg font-normal tracking-wide text-white transition-all hover:border-black hover:bg-black md:w-fit";

export default function ContentButton(button: ContentSectionButton_Fields) {
  const [videoPopupOpen, setVideoPopupOpen] = useState(false);

  return button.video ? (
    <>
      <button onClick={() => setVideoPopupOpen(true)} className={buttonClass}>
        {button.text}
      </button>
      <VideoPopup
        isOpen={videoPopupOpen}
        ignoreCookies={false}
        callback={() => setVideoPopupOpen(false)}
        videoSourceUrl={button.link?.url ?? ""}
        isPrismicVideo={false}
        title="Video"
      />
    </>
  ) : (
    <CustomLink to={button.link?.url} className={buttonClass}>
      {button.text}
    </CustomLink>
  );
}
